// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"b6be7acd","267":"13986678","317":"203bddc9","898":"9ab4f53e","916":"8aaddedc"}[chunkId] + ".chunk.js";
};